// External tool links surfaced in the UI, overridable per deployment
// via Vite env vars (set in .env.local or Cloudflare Pages build env).

/** VN2R self-hosted instance of the open-source ifc-georeferencer
 *  (fork: github.com/RPGAVINA/ifc-georeferencer, upstream:
 *  bedrock-engineer/ifc-georeferencer, Apache-2.0). Places an IFC on a
 *  real map and writes IfcMapConversion + IfcProjectedCRS back into the
 *  file, fully client-side. The viewer then reads that georeferencing
 *  natively on load. */
export const GEOREF_URL: string =
  import.meta.env.VITE_GEOREF_URL ??
  'https://rpgavina.github.io/ifc-georeferencer/'
